import events from './events'
import store from 'reducers'
import Actions from './Actions'

export default class SelectedPatientActions extends Actions{
    static get target(){
        return 'selectedPatients'
    }

    static clear(){
        this.set({})
    }
}


// WEBPACK FOOTER //
// ./actions/SelectedPatientActions.js